import React from "react";
import { Button } from "@/components/ui/button";
import { Lead, LeadOutcome } from "../types/LeadTypes";
import OutcomeSelect from "../LeadOutcome";
import ValueInput from "../ValueInput";
import AudioPlayback from "../AudioPlayback";
import FormFields from "../FormFields";

interface LeadItemDetailsProps {
  lead: Lead;
  onOutcomeChange: (value: LeadOutcome | null) => void;
  onValueChange: (value: string) => void;
  openTranscriptModal: () => void;
}

const LeadItemDetails: React.FC<LeadItemDetailsProps> = ({
  lead,
  onOutcomeChange,
  onValueChange,
  openTranscriptModal,
}) => {
  // Estimated revenue - default to $1000
  const estimatedRevenue = "$1000";

  // Check if the outcome is a disqualified type
  const isDisqualified =
    lead.outcome?.includes("Disqualified") ||
    lead.outcome === "Existing Customer";

  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Outcome
        </label>
        <OutcomeSelect outcome={lead.outcome} onChange={onOutcomeChange} />
      </div>

      {!isDisqualified && (
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Value
          </label>
          <ValueInput
            value={lead.value}
            onChange={onValueChange}
            outcome={lead.outcome}
            estimatedRevenue={estimatedRevenue}
          />
        </div>
      )}

      {lead.aiSummary && (
        <div>
          <h3 className="font-medium text-gray-700 mb-1">AI Summary</h3>
          <p className="text-sm">{lead.aiSummary}</p>
        </div>
      )}

      {lead.type === "Call" && lead.audioDuration && (
        <AudioPlayback duration={lead.audioDuration} audioUrl={lead.audioUrl} />
      )}

      {lead.type === "Form" && lead.formFields && (
        <FormFields fields={lead.formFields} />
      )}

      {lead.type === "Call" &&
        lead.transcription_json &&
        lead.transcription_json.length > 0 && (
          <div>
            <Button
              variant="link"
              className="text-sm p-0 h-auto underline text-black"
              onClick={openTranscriptModal}
            >
              Read Transcript
            </Button>
          </div>
        )}
    </div>
  );
};

export default LeadItemDetails;
